import React from 'react';
import { WeaLocaleProvider } from 'ecCom';
import { addContentPath } from '../../util/pathUtil';
const getLabel = WeaLocaleProvider.getLabel;
import Header from './Common/header';

export default class Content_addWF extends React.Component {
    render() {
        const { data = {}, eid } = this.props;
        const { moreLocal, iconMore } = data;

        const tr = (<tr className="element_prew_sparator" height="1px">
            <td colSpan="3" />
        </tr>);
        const tr1 = (
            <tr height="18">
                <td width="8"><img src={addContentPath('/images/homepage/style/style1/esymbol_wev8.gif')} alt="" /></td>
                <td width="*"><a href="javascript:;"><font className="font">{getLabel(387822, '曾东平')}</font></a></td>
                <td width="100" align="right"><a href="javascript:;"><font className="font">{66666666666}</font></a></td>
            </tr>
        );
        return (
            <div className="item" id={`item_${eid}`}>
                <Header ecId={`${this && this.props && this.props.ecId || ''}_Header@9fdmt1`} data={data} eid={eid} />
                <div className="content" id={`content_${eid}`}>
                    <div className="content_view" id={`content_view_id_${eid}`}>
                        <div className="ant-search-input-wrapper" style={{ width: '300px', marginTop: '5px' }}>
                            <span className="ant-input-group ant-search-input">
                                    <span className="ant-input-wrapper">
                                        <input placeholder={getLabel(83815, '搜索姓名/首字母/手机号')} type="text" className="ant-input" value="" style={{ top: '2px', right: '3px' }} />
                                    </span>
                                    <div className="ant-input-group-wrap" style={{ paddingTop: '2px' }}>
                                        <button type="button" className="ant-btn ant-btn-icon-only ant-search-btn">
                                            <i className="anticon anticon-search" />
                                        </button>
                                    </div>
                            </span>
                        </div>
                        <div className="tab2">
                            <table height="32" cellSpacing="0" cellPadding="0">
                                <tr>
                                    <td className="tab2selected" style={{ width: '84px' }}>{getLabel(24515, '最近') }</td>
                                    <td className="tab2unselected" style={{ width: '84px' }}>{getLabel(18511, '同部门') }</td>
                                    <td className="tab2unselected" style={{ width: '84px' }}>{getLabel(15089, '我的下属') }</td>
                                </tr>
                            </table>
                        </div>
                        <table width="100%">
                            {tr1}{tr}{tr1}{tr}{tr1}{tr}{tr1}{tr}{tr1}
                        </table>
                    </div>
                    <div className="footer" id={`footer_${eid}`} style={{ textAlign: 'right' }}>
                        {moreLocal == 'footer' ? <a href="javascript:;"><img src={addContentPath(iconMore)} alt="" /></a> : ''}
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4public/wea-element-preview/content/Content_contacts.js